export default __webpack_public_path__ + "static/media/canary-level-1.d3390cc2.svg";